import React from 'react';

import { Skeleton, SkeletonSize } from '@/shared/ui';

export const TeamSkeletonRow: React.FC = () => {
    return (
        <tr className='h-[72px] border-b border-gray-300'>
            <td className='pl-6'>
                <div className='flex items-center'>
                    <div className='flex flex-col gap-2 ml-3'>
                        <Skeleton size={SkeletonSize.Small} />
                    </div>
                </div>
            </td>
            <td>
                <div className='flex items-center'>
                    <Skeleton size={SkeletonSize.Avatar} />
                    <div className='flex flex-col gap-2 ml-3'>
                        <Skeleton size={SkeletonSize.Default} />
                        <Skeleton size={SkeletonSize.Small} />
                    </div>
                </div>
            </td>
            <td>
                <div className='flex flex-col gap-2'>
                    <Skeleton size={SkeletonSize.Small} />
                </div>
            </td>
            <td>
                <div className='flex flex-col gap-2'>
                    <Skeleton size={SkeletonSize.Small} />
                </div>
            </td>
            <td>
                <div className='flex flex-col gap-2'>
                    <Skeleton size={SkeletonSize.Small} />
                </div>
            </td>
            <td>
                <div className='flex flex-col gap-2'>
                    <Skeleton size={SkeletonSize.Button} />
                </div>
            </td>
        </tr>
    );
};
